import React from 'react';
import { Col } from 'reactstrap';
import PageFilterModal from './PageFilterModal';

const PageFilterLayout = ({
  filterData,
  isFilterSidebarVisible,
  isFilterModalOpen,
  closeFilterModal,
  children,
}) => {
  if (!filterData) return null;

  if (isFilterSidebarVisible) {
    return <Col xl={3}>{children}</Col>;
  }

  if (isFilterModalOpen) {
    return (
      <PageFilterModal isOpen={isFilterModalOpen} onClose={closeFilterModal}>
        {children}
      </PageFilterModal>
    );
  }

  return null;
};

export default PageFilterLayout;
